import Close from '@library/Close/Close';
import Button from '@library/Button/Button';
import { useTranslation } from '@utils/i18n/i18n.consumers';

import './guided-tour-tooltip.styl';

function GuidedTourTooltip(props) {
  const { t } = useTranslation();
  const { 
    index, isLastStep, size, step, backProps, closeProps, primaryProps, skipProps, tooltipProps,
  } = props;
  const { title, content } = step;

  return (
    <div 
      className="guided-tour-tooltip" 
      aria-modal={tooltipProps['aria-modal']} 
      role={tooltipProps.role} 
      ref={tooltipProps.ref}
    >
      <div className="guided-tour-tooltip__header">
        { title && <div className="guided-tour-tooltip__header__title">{title}</div> }
        <Close
          key="guided-tour-close" 
          aria-label={closeProps['aria-label']} 
          data-action={closeProps['data-action']} 
          role={closeProps.role} 
          title={closeProps.title} 
          onClick={closeProps.onClick}
        />
      </div>
      <div className="guided-tour-tooltip__body">
        {content}
      </div>
      <div className="guided-tour-tooltip__footer">
        <div className="guided-tour-tooltip__footer__flex">
          { !isLastStep && (
          <Button 
            classType="flat" 
            aria-label={skipProps['aria-label']} 
            data-action={skipProps['data-action']} 
            role={skipProps.role} 
            title={skipProps.title} 
            onClick={skipProps.onClick}
          >
            {t('Skip')}
          </Button>
          ) }
        </div>
        <div className="guided-tour-tooltip__footer__nav">
          { (index > 0) && (
          <Button 
            key="guided-tour-back" 
            classType="flat" 
            aria-label={backProps['aria-label']} 
            data-action={backProps['data-action']} 
            role={backProps.role} 
            title={backProps.title} 
            onClick={backProps.onClick}
          >
            {t('Back')}
          </Button>
          )} 
          <Button 
            key="guided-tour-next" 
            classType="primary" 
            aria-label={primaryProps['aria-label']} 
            data-action={primaryProps['data-action']} 
            role={primaryProps.role} 
            title={primaryProps.title} 
            onClick={primaryProps.onClick}
          >
            {isLastStep ? t('Finish') : t('Next')}
            <sup>{`(${index + 1}/${size})`}</sup>
          </Button>
        </div>
      </div>
    </div>
  )
}

export default GuidedTourTooltip;
